// Un souci ? (lot 5.6) : le rapport de diagnostic, relu avant de partir. On voit exactement ce que l'administrateur
// recevra (la version, les notifications, l'état des connexions, les tâches en échec), sans aucune note ni aucun
// contenu, et on peut y ajouter un message.

import { useEffect, useState } from 'react';

import type { Actions } from '../App';
import { EnTeteRetour, Fenetre } from '../components';
import { type RapportDiagnostic, api } from '../lib/api';

const ETATS: Record<string, string> = { ok: 'connecté', a_reconnecter: 'à reconnecter', erreur: 'en erreur' };
const date = (iso: string | null) => (iso ? new Date(iso).toLocaleString('fr-FR', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' }) : 'jamais');

export function Diagnostic({ actions }: { actions: Actions }) {
  const [rapport, setRapport] = useState<RapportDiagnostic | null>(null);
  const [message, setMessage] = useState('');
  const [envoye, setEnvoye] = useState(false);

  useEffect(() => {
    api.diagnostic().then(setRapport).catch((e: Error) => actions.toast({ texte: e.message, erreur: true }));
  }, [actions]);

  const envoyer = async () => {
    try {
      await api.envoyerDiagnostic(message.trim());
      setEnvoye(true);
    } catch (e) {
      actions.toast({ texte: (e as Error).message, erreur: true });
    }
  };

  return (
    <main className="ecran">
      <EnTeteRetour titre="Un souci ?" retour="#/reglages" />
      {envoye ? (
        <Fenetre><p className="message" style={{ margin: 0 }}>Rapport envoyé. L’administrateur d’Alfred le verra rapidement.</p></Fenetre>
      ) : (
        <>
          <Fenetre>
            <p className="muted" style={{ margin: 0, fontSize: 13 }}>
              Voici exactement ce que recevra l’administrateur d’Alfred. Aucune note, aucun rappel, aucune conversation : seulement l’état technique.
            </p>
            {!rapport && <p className="muted" style={{ margin: 0 }}>Chargement…</p>}
            {rapport && (
              <ul className="rapport">
                <li>Version : {rapport.version}</li>
                <li>Appareils qui reçoivent les notifications : {rapport.notifications.abonnements}</li>
                {rapport.connexions.length === 0 && <li>Aucune connexion</li>}
                {rapport.connexions.map((c, n) => (
                  <li key={n}>Connexion {c.fournisseur} : {ETATS[c.etat] ?? c.etat}, dernière synchro {date(c.derniere_synchro_le)}{c.erreur ? ` (${c.erreur})` : ''}</li>
                ))}
                {rapport.taches_en_echec.length === 0 ? <li>Aucune tâche en échec ces 3 derniers jours</li> : rapport.taches_en_echec.map((t, n) => (
                  <li key={`t${n}`}>Échec {t.type} le {date(t.debut)} : {t.resume}</li>
                ))}
              </ul>
            )}
          </Fenetre>
          <Fenetre>
            <textarea className="saisie texte" rows={4} maxLength={1000} placeholder="Décrivez le souci, si vous voulez (« les rappels ne sonnent plus depuis hier »…)" value={message} onChange={(e) => setMessage(e.target.value)} aria-label="Votre message" />
            <button className="btn principal" disabled={!rapport} onClick={() => void envoyer()}>Envoyer le rapport</button>
          </Fenetre>
        </>
      )}
    </main>
  );
}
